// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import { Link, Button } from '../../../internal/Button';

type PropTypes = {|
  policyHref: string,
|};

const localStorageKey = 'CookieNotificationAccept';
const localStorageValue = 'True';

const CookieNotification = (props: PropTypes) => {
  if (typeof window === 'undefined') {
    return null;
  }

  let hasAccepted = false;
  if (window.localStorage && window.localStorage.getItem(localStorageKey) === localStorageValue) {
    hasAccepted = true;
  }

  const [isHidden, hideNotification] = React.useState(hasAccepted);

  const onClick = () => {
    if (window.localStorage) {
      window.localStorage.setItem(localStorageKey, localStorageValue);
    }
    hideNotification(true);
  };

  if (isHidden) {
    return false;
  }

  return (
    <div className={styles.container}>
      <p className={styles.content}>
        {'Use of this site accepts the '}
        {!window.location.href.includes(props.policyHref) ? (
          <Link href={props.policyHref} className={styles.link} variant="WhiteLink" size="Tiny">
            use of cookies
          </Link>
        ) : (
          <span>use of cookies</span>
        )}
        .
        <span className={styles.buttonContainer}>
          <Button
            onClick={onClick}
            className={styles.button}
            size="Tiny"
            variant="DefaultInverse"
            data-testid="close-cookie-notification"
          >
            OK
          </Button>
        </span>
      </p>
    </div>
  );
};

export default CookieNotification;
